<template>
  <div class="settings__group">
    <h2>{{ title }}</h2>
    <div class="settings__group__content">
      <ul>
        <li v-for="(option, index) in options"
            :key="index"
            :class="option.innerClass">

          <template v-if="option.type === types.SELECT">
            <div class="settings-left">
              <h3>{{ option.name }}</h3>
            </div>
            <div :class="['settings-right', option.styleClass]">
              <ul>
                <li v-for="(value, key, index) in option.options"
                    :key="index"
                    style="cursor: pointer">
                  <a @click.prevent="onSelect(option.id, { key, value: value[0] })">
                    {{ value[1] }}
                  </a>
                </li>
              </ul>
            </div>
          </template>
          <template v-else-if="option.type === types.CHECKBOX">
            <div class="settings-left">
              <h3>{{ option.name }}</h3>
            </div>
            <div :class="['settings-right', option.styleClass]">
              <div class="onoffswitch">
                <input type="checkbox"
                       name="onoffswitch"
                       class="onoffswitch-checkbox"
                       :id="`checkbox_${index}`"
                       @change="onSelect(option.id)"
                       :checked="option.value">
                <label class="onoffswitch-label"
                       :for="`checkbox_${index}`">
                  <span></span>
                </label>
              </div>
            </div>
          </template>
          <a v-else
             style="cursor: pointer"
             @click.prevent="onSelect(option.id)">
            <div class="settings-left">
              <h3>{{ option.name }}</h3>
            </div>
            <div :class="['settings-right', options.styleClass]">
              <i class="icon-arrow-right"></i>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settings-group',
  emits: ['select'],
  inject: ['types'],
  props: {
    title: String,
    options: Array,
  },
  methods: {
    onSelect(key, value) {
      this.$emit('select', { key, value });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/SettingsGroup.vue